'use client';

import { c as _c } from "react/compiler-runtime";
import { useSession } from '@/lib/auth-client';
import { useUserVote, useAddVote, useRemoveVote, useEngagementSummary } from '@/lib/hooks';
import clsx from 'clsx';
import { ThumbsUp, ThumbsDown } from 'lucide-react';
interface VoteButtonsProps {
  objectId: string;
  objectType: 'item' | 'collection' | 'entity' | 'collection_item' | 'initiative' | 'content';
}
export function VoteButtons(t0) {
  const $ = _c(37);
  const {
    objectId,
    objectType
  } = t0;
  const {
    data: session
  } = useSession();
  let t1;
  if ($[0] !== session?.user?.id) {
    t1 = session?.user?.id?.toString();
    $[0] = session?.user?.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currentUserId = t1;
  const {
    data: userVote
  } = useUserVote(currentUserId || "", objectId, objectType);
  const addVote = useAddVote();
  const removeVote = useRemoveVote();
  let t2;
  if ($[2] !== addVote || $[3] !== currentUserId || $[4] !== objectId || $[5] !== objectType || $[6] !== removeVote || $[7] !== userVote) {
    t2 = async direction => {
      if (!currentUserId) {
        return;
      }
      if (userVote === direction) {
        await removeVote.mutateAsync({
          actorId: currentUserId,
          objectId,
          objectType
        });
      } else {
        await addVote.mutateAsync({
          objectId,
          objectType,
          vote: direction
        });
      }
    };
    $[2] = addVote;
    $[3] = currentUserId;
    $[4] = objectId;
    $[5] = objectType;
    $[6] = removeVote;
    $[7] = userVote;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleVote = t2;
  if (!session?.user) {
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="flex flex-col items-center gap-1 p-3 bg-gray-50 rounded-xl border border-gray-200"><span className="text-xs text-gray-500">Sign in to vote</span></div>;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  const isPending = addVote.isPending || removeVote.isPending;
  let t3;
  if ($[10] !== handleVote) {
    t3 = () => handleVote("up");
    $[10] = handleVote;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const t4 = userVote === "up" ? "bg-gray-100 text-gray-900" : "bg-transparent text-gray-900 hover:bg-gray-50";
  const t5 = isPending && "opacity-50 cursor-not-allowed";
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = clsx("p-2 rounded-lg transition-all hover:scale-110 active:scale-95", t4, t5);
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = userVote === "up" ? "currentColor" : "none";
  let t8;
  if ($[15] !== t7) {
    t8 = <ThumbsUp className="w-5 h-5" fill={t7} />;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== isPending || $[18] !== t3 || $[19] !== t6 || $[20] !== t8) {
    t9 = <button onClick={t3} disabled={isPending} className={t6} title="Upvote">{t8}</button>;
    $[17] = isPending;
    $[18] = t3;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== handleVote) {
    t10 = () => handleVote("down");
    $[22] = handleVote;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = userVote === "down" ? "bg-gray-100 text-gray-900" : "bg-transparent text-gray-900 hover:bg-gray-50";
  const t12 = isPending && "opacity-50 cursor-not-allowed";
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = clsx("p-2 rounded-lg transition-all hover:scale-110 active:scale-95", t11, t12);
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const t14 = userVote === "down" ? "currentColor" : "none";
  let t15;
  if ($[27] !== t14) {
    t15 = <ThumbsDown className="w-5 h-5" fill={t14} />;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== isPending || $[30] !== t10 || $[31] !== t13 || $[32] !== t15) {
    t16 = <button onClick={t10} disabled={isPending} className={t13} title="Downvote">{t15}</button>;
    $[29] = isPending;
    $[30] = t10;
    $[31] = t13;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t16 || $[35] !== t9) {
    t17 = <div className="flex items-center gap-2">{t9}{t16}</div>;
    $[34] = t16;
    $[35] = t9;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
}